import { render, staticRenderFns } from "./EditExtraFeatures.vue?vue&type=template&id=390204b6&scoped=true"
import script from "./EditExtraFeatures.vue?vue&type=script&lang=js"
export * from "./EditExtraFeatures.vue?vue&type=script&lang=js"
import style0 from "./EditExtraFeatures.vue?vue&type=style&index=0&id=390204b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390204b6",
  null
  
)

export default component.exports